<div>
  @if(hasFilter) {
    <div class="mb-4">
      <p-iconfield>
        <p-inputicon styleClass="pi pi-search" />
        <input pInputText type="text" [(ngModel)]="globalFilter" placeholder="Búsqueda rápida" class="w-full md:w-80" />
      </p-iconfield>
    </div>
  }

  <!-- Desktop -->
  <div class="hidden md:block">
    <p-table
      #dt
      [value]="tableData"
      [paginator]="tableData.length > 10"
      [rows]="10"
      [globalFilterFields]="filterFields"
      [scrollable]="true"
      scrollHeight="flex"
      styleClass="p-datatable-sm p-datatable-striped"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'Mostrando {first} a {last} de {totalRecords}'"
    >
      <ng-template #header>
        <tr>
          @for(col of visibleHeaders; track col.key) {
            @if(col.key === iconColumn) {
              <th class="w-[80px] text-center">{{ col.textHeader }}</th>
            } @else {
              <th [pSortableColumn]="col.key">
                {{ col.textHeader }}
                <p-sortIcon [field]="col.key" />
              </th>
            }
          }
          @if(hasButton) { <th class="w-[120px]">Acciones</th> }
        </tr>
      </ng-template>

      <ng-template #body let-item>
        <tr class="cursor-pointer" (click)="selectOne(item)"
          [ngClass]="{'bg-vivid-royal-100 dark:bg-vivid-royal-800': item.type === 2}">
          @for(col of visibleHeaders; track col.key) {
            @if(col.key === iconColumn) {
              <td class="text-center">
                @switch(item.type) {
                  @case(0) { <i class="pi pi-circle text-gray-300"></i> }
                  @case(1) { <i class="pi pi-check-circle text-green-500"></i> }
                  @case(2) { <i class="pi pi-check-circle text-vivid-royal-500"></i> }
                  @case(4) { <i class="pi pi-minus-circle text-red-400"></i> }
                }
              </td>
            } @else {
              <td>
                @if(col.type === 'date') {
                  {{ item[col.key] | date:'dd/MM/YYYY' }}
                } @else if(col.type === 'fullTime') {
                  {{ item[col.key] | date:'dd/MM/YYYY hh:mm a' }}
                } @else if(col.type === 'currency') {
                  {{ item[col.key] | currency }}
                } @else {
                  {{ item[col.key] }}
                }
              </td>
            }
          }
          @if(hasButton) {
            <td>
              <div class="flex gap-1">
                @for(btn of actions; track btn.text) {
                  @if(item['buttons']) {
                    @for(ib of item['buttons']; track ib; let i = $index) {
                      @if(ib === btn.text) {
                        <app-custom-table-button [showButtonText]="btn.showText"
                          [color]="(item.colors && item.colors[i]) ? item.colors[i] : btn.color"
                          [textButton]="btn.text" [hasIcon]="btn.hasIcon" [icon]="btn.icon"
                          (onClick)="btn.action(item)"></app-custom-table-button>
                      }
                    }
                  } @else if(!item.disableButton) {
                    <app-custom-table-button [showButtonText]="btn.showText"
                      [color]="btn.color" [textButton]="btn.text" [hasIcon]="btn.hasIcon"
                      [icon]="btn.icon" (onClick)="btn.action(item)"></app-custom-table-button>
                  }
                }
              </div>
            </td>
          }
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td [attr.colspan]="visibleHeaders.length + (hasButton ? 1 : 0)" class="text-center py-6">
            {{ emptyTableMessage }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Mobile Cards -->
  <div class="block md:hidden space-y-3">
    @for(item of tableData; track $index) {
      <div class="bg-white dark:bg-crayola-blue-800 rounded-lg shadow-sm p-4 space-y-2 cursor-pointer"
        (click)="selectOne(item)"
        [ngClass]="{'ring-2 ring-vivid-royal-500': item.type === 2}">
        @for(col of visibleHeaders; track col.key) {
          @if(col.key !== iconColumn) {
            <div class="flex justify-between text-sm">
              <span class="font-semibold text-vivid-royal-700 dark:text-vivid-royal-200">{{ col.textHeader }}</span>
              <span class="text-right text-vivid-royal-900 dark:text-white">{{ item[col.key] }}</span>
            </div>
          }
        }
        @if(hasButton) {
          <div class="flex flex-wrap gap-2 pt-2 border-t border-dark-khaki-200 dark:border-vivid-royal-700">
            @for(btn of actions; track btn.text) {
              @if(!item.disableButton) {
                <button pButton [label]="btn.text" class="p-button-sm p-button-outlined" (click)="$event.stopPropagation(); btn.action(item)"></button>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</div>
